export default __webpack_public_path__ + "static/screenhills-90a9489ec79e423bddde50d6fe24a679.png";